<div class="ui-g ui-fluid clear-ui">
    <div class="ui-g-12">
        <h1 class="card__title--h1 color--white layout-page-title">Companies</h1>
    </div>
    <div class="ui-g-12 ui-xl-6">
        <div class="card p-p-0">
            <p-table #tableCompanies [columns]="cols" [value]="companies" selectionMode="single" dataKey="id"
                [(selection)]="selected" [paginator]="true" [rows]="10" [scrollable]="true" paginatorPosition="bottom"  styleClass="p-datatable-striped">
                <ng-template pTemplate="caption">
                    <div class="ui-helper-clearfix p-text-left">
                        <button icon="ui-icon-add" label="New" pButton (click)="createCompany()"></button>
                        <!-- <button pButton icon="ui-icon-cloud-download" iconPos="left" label="Download CSV"
                            (click)="tableCompanies.exportCSV()"></button> -->
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                        <th class="p-text-right">
                            Actions
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData" (dblclick)="viewCompany(rowData)">
                        <td *ngFor="let col of columns">
                            {{rowData[col.field]}}
                        </td>
                        <td class="p-text-right">
                            <button class="ui-button-information ui-button__center" pButton
                                (click)="viewCompany(rowData)" pTooltip="Edit" tooltipPosition="top"
                                icon="ui-icon-edit"></button>
                            <button class="ui-button-information ui-button__center" pButton
                                (click)="deleteCompany(rowData)" pTooltip="Delete" tooltipPosition="top"
                                icon="ui-icon-delete"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
